import type { PaymentMethodItem } from '../../../PaymentMethods.types'
import { getDefaultPaymentMethod } from '../../../utils/getDefaultPaymentMethod'

export const getErrorBanner = (paymentMethods?: PaymentMethodItem[]) => {
  const defaultPaymentMethod = getDefaultPaymentMethod(paymentMethods)

  if (defaultPaymentMethod && 'expired' in defaultPaymentMethod && defaultPaymentMethod.expired) {
    return 'Your default payment method is expired. Update your payment method to prevent blocked transactions.'
  }

  if (defaultPaymentMethod?.invalid) {
    return 'We were unable to charge your payment method. Update your payment method to prevent blocked transactions.'
  }

  return undefined
}
